import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";

import {
  IWesterosClientProfilesListReturnType,
  getWesterosClientProfilesList,
} from "api";
import { Nullable } from "config";
import { RootState } from "store/store";

import { WesterosClientsModalMode } from "./enums";
import { IWesterosClientsModalData } from "./types";

const initialState = {
  clientProfilesData: null as Nullable<
    IWesterosClientProfilesListReturnType["edges"]
  >,
  totalCount: 1,
  loading: false,
  modalData: {
    open: false,
    mode: WesterosClientsModalMode.VIEW,
  } as IWesterosClientsModalData,
};

export const fetchWesterosClients = createAsyncThunk(
  "westeros-clients/fetchWesterosClients",
  async (_, { getState }) => {
    try {
      const filters = (getState() as RootState).FiltersReducer;
      if (!Object.values(filters).length) {
        return;
      }

      const response = await getWesterosClientProfilesList(filters);
      return response;
    } catch (error) {
      throw error;
    }
  }
);

const westerosClientsSlice = createSlice({
  name: "westeros-clients",
  initialState,
  reducers: {
    setWesterosClientModalData: (
      state,
      action: PayloadAction<IWesterosClientsModalData>
    ) => {
      state.modalData = action.payload;
    },
    closeWesterosClientModal: (state) => {
      state.modalData = initialState.modalData;
    },
    switchWesterosClientModalMode: (state) => {
      state.modalData.mode = WesterosClientsModalMode.EDIT;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchWesterosClients.fulfilled, (state, action) => {
      if (!action.payload) {
        return {
          ...state,
          loading: false,
        };
      }
      return {
        ...state,
        clientProfilesData: action.payload?.edges,
        totalCount: action.payload?.totalCount,
        loading: false,
      };
    });
    builder.addCase(fetchWesterosClients.pending, (state) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(fetchWesterosClients.rejected, (state) => {
      return {
        ...state,
        loading: false,
      };
    });
  },
});

export const {
  setWesterosClientModalData,
  closeWesterosClientModal,
  switchWesterosClientModalMode,
} = westerosClientsSlice.actions;

export default westerosClientsSlice.reducer;
